import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/layout/PageHeader';
import { FaEnvelope, FaArrowRight } from 'react-icons/fa';
import RedirectCountdown from '../../components/layout/RedirectCountdown';
import pageContent from '../../cms/page-content.json';
import RichText from '../../components/ui/RichText';
import '../../css/parents/GetConnected.css';

const ParentGetConnected = () => {
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRedirecting(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleRedirectComplete = () => {
    navigate('/mailing-list', { replace: true });
  };

  return (
    <>
      <PageHeader 
        title={pageContent.pgcTitle} 
        subtitle={pageContent.pgcSubtitle}
      />
      
      <div className="get-connected-container">
        <div className="get-connected-content">
          <div className="get-connected-icon">
            <FaEnvelope />
          </div>
          <h2>{pageContent.pgcHeading}</h2>
          <RichText value={pageContent.pgcBody} />
          <div className="get-connected-actions">
            <button 
              className="get-connected-button"
              onClick={() => navigate('/mailing-list')}
            >
              <FaArrowRight /> {pageContent.pgcButtonText}
            </button>
            <button 
              className="get-connected-back-button"
              onClick={() => navigate('/parents')}
            >
              {pageContent.pgcBackButtonText}
            </button>
          </div>
        </div>
      </div>

      {isRedirecting && (
        <RedirectCountdown 
          seconds={10}
          onComplete={handleRedirectComplete}
        />
      )}
    </>
  );
};

export default ParentGetConnected;
